var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.143,
    height: 16.913,
    viewBox: "0 0 15.143 16.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact_Details",
    "data-name": "Contact Details",
    transform: "translate(-193.671 -172.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M206.848,172.36h-11.21a1.967,1.967,0,0,0-1.967,1.967v12.98a1.967,1.967,0,0,0,1.967,1.967h11.21a1.967,1.967,0,0,0,1.967-1.967v-12.98a1.967,1.967,0,0,0-1.967-1.967Zm-10.423,16.127h-.787a1.18,1.18,0,0,1-1.18-1.18v-12.98a1.18,1.18,0,0,1,1.18-1.18h.787Zm11.6-1.18h0a1.18,1.18,0,0,1-1.18,1.18h-9.636v-15.34h9.636a1.18,1.18,0,0,1,1.18,1.18Z",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M352.622,274.245a2.144,2.144,0,1,0-1.514-.628A2.142,2.142,0,0,0,352.622,274.245Zm0-3.5a1.357,1.357,0,1,1-.958.4,1.355,1.355,0,0,1,.958-.4Z",
    transform: "translate(-150.297 -93.549)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M318.348,381.605a3.958,3.958,0,0,0-3.589,2.073.394.394,0,0,0-.037.169v1.617a.394.394,0,0,0,.393.393h6.466a.393.393,0,0,0,.393-.393v-1.617a.394.394,0,0,0-.037-.169,3.957,3.957,0,0,0-3.589-2.073Zm2.84,3.465h-5.68v-1.125a3.332,3.332,0,0,1,5.68,0Z",
    transform: "translate(-116.024 -200.555)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.afd7e2c0f45de9729767dd64eb651070.svg";
export { ForwardRef as ReactComponent };